<template>
  <div>
    <el-dialog title="查看磅单" center :visible.sync="BDVisible" width='50%' :close-on-click-modal="false" :before-close="RCQuXiao">
        <div class="demo-image__preview" v-if="!lookFlag">
          <div>
            <!-- <p>证件信息</p> -->
            <!-- <hr> -->
            <span v-for="(item, index) in imgList" :key="index">
              <el-image
              :preview-src-list="getSrcList(index,imgList)"
              fit="cover"
              :src="item"
              style="width:200px;height:180px;margin:0 20px 20px;">
              </el-image>
            </span>
            <span v-if="imgList.length==0">暂无信息</span>
          </div>
        </div>
        <span v-if="lookFlag">暂无信息</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="RCQuXiao">关 闭</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { getImgShow } from '@/api/wms-stock'
export default {
  name: 'BDImg',
  data () {
    return {
      lookFlag: false,
      imgList: [],
      tableList: [{}]
    }
  },
  props: {
    BDVisible: {
      type: Boolean,
      default: false
    },
    outstockSummaryId: {
      type: Number
    }
  },
  mounted () {
    this.getInfos()
  },
  methods: {
    RCQuXiao () {
      this.$emit('update:BDVisible', false)
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      // const list = arr.map(item => item.imgUrl)
      return arr.slice(index).concat(arr.slice(0, index))
    },
    getInfos () {
      const that = this
      getImgShow({
        businessId: that.outstockSummaryId,
        businessType: 'out_stock_weight_image'
      })
        .then(res => {
          console.log(res)
          if (res.length != 0) {
            // const dataBackups = JSON.parse(res)
            that.imgList.push(res[0].url)
            // that.imgList.push(dataBackups.appendix2Url)
            // that.imgList.push(dataBackups.identityPhoto1Url)
            // that.imgList.push(dataBackups.identityPhoto2Url)
            // that.imgList.push(dataBackups.qualificationPhotoUrl)
          }
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    }
  }

}
</script>

<style>

</style>
